import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { CompanyService } from "Services/CompanyService";

const EditSubscription = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState<any>({
    company: "",
    plan: "",
    startDate: "",
    expiryDate: "",
    // status: "active",
  });

  const [loading, setLoading] = useState(false);

  const getSubscriptionDetails = async () => {
    try {
      if (!id) return;

      const res = await CompanyService.getSubscriptionById(id);

      if (res.status === 200) {
        const data = res.data.data;

        setFormData({
          company: data.company?.name,
          plan: data.plan?.name,
          startDate: data.startDate?.slice(0, 10),
          expiryDate: data.expiryDate?.slice(0, 10),
          //   status: data.status,
        });
      }
    } catch (error) {
      console.error("Error fetching subscription", error);
    }
  };

  useEffect(() => {
    getSubscriptionDetails();
  }, []);

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      if (!id) return;

      setLoading(true);

      const payload = {
        company: formData.company,
        plan: formData.plan,
        // status: formData.status,
        startDate: formData.startDate,
        expiryDate: formData.expiryDate,
      };

      const res = await CompanyService.updateSubscription(id, payload);

      if (res.status === 200) {
        console.log("Subscription updated");

        navigate("/admin-dash/subscription");
      }
    } catch (error) {
      console.error("Update failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="company-page">
      <Card className="company-card shadow-lg border-0">
        <Card.Body>
          {/* Header */}

          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 className="fw-bold mb-1">Edit Subscription</h4>

              <small className="text-muted">
                Update subscription configuration
              </small>
            </div>

            <Button variant="light" onClick={() => navigate(-1)}>
              ← Back
            </Button>
          </div>

          {/* Form */}

          <Card className="border-0 shadow-sm mb-4">
            <Card.Body>
              <h6 className="fw-bold mb-3">Subscription Information</h6>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Company</Form.Label>

                    <Form.Control
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Plan</Form.Label>

                    <Form.Control
                      name="plan"
                      value={formData.plan}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>

                    <Form.Control
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Expiry Date</Form.Label>

                    <Form.Control
                      type="date"
                      name="expiryDate"
                      value={formData.expiryDate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  {/* <Form.Group>

                    <Form.Label>Status</Form.Label>

                    <Form.Select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >

                      <option value="active">Active</option>
                      <option value="cancelled">Cancelled</option>
                      <option value="expired">Expired</option>

                    </Form.Select>

                  </Form.Group> */}
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Buttons */}

          <div className="d-flex justify-content-end">
            <Button
              variant="light"
              className="me-2"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>

            <Button
              className="create-plan-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Subscription"}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default EditSubscription;
